var render = function render(){
  var _vm$approvals;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [(_vm$approvals = _vm.approvals) !== null && _vm$approvals !== void 0 && _vm$approvals.length ? _vm._l(_vm.approvals, function (item, index) {
    return _c('b-row', {
      key: item._uid || index,
      staticClass: "mb-2"
    }, [_c('b-col', {
      attrs: {
        "md": "11"
      }
    }, [!_vm.isDetail ? [_c('v-select', {
      attrs: {
        "id": "approval_id",
        "options": _vm.getAvailableApprovalOptions(index),
        "reduce": function reduce(val) {
          return val.value;
        },
        "label": "text",
        "placeholder": "Select Approval",
        "appen": ""
      },
      on: {
        "input": function input(val) {
          return _vm.onChangeApproval(index, val);
        }
      },
      scopedSlots: _vm._u([{
        key: "option",
        fn: function fn(_ref) {
          var text = _ref.text,
            photo = _ref.photo,
            position = _ref.position;
          return [_c('div', {
            staticClass: "d-flex align-items-center"
          }, [_c('img', {
            staticClass: "rounded-circle mr-2",
            attrs: {
              "src": photo || _vm.$getInitials(text),
              "alt": "avatar",
              "width": "30",
              "height": "30"
            }
          }), _c('div', [_c('div', {
            staticClass: "font-weight-bold"
          }, [_vm._v(_vm._s(text))]), _c('small', {
            staticClass: "text-muted"
          }, [_vm._v(_vm._s(position))])])])];
        }
      }, {
        key: "selected-option",
        fn: function fn(_ref2) {
          var text = _ref2.text,
            photo = _ref2.photo;
          return [_c('div', {
            staticClass: "d-flex align-items-center"
          }, [_c('img', {
            staticClass: "rounded-circle mr-2",
            attrs: {
              "src": photo || _vm.$getInitials(text),
              "alt": "avatar",
              "width": "25",
              "height": "25"
            }
          }), _c('span', [_vm._v(_vm._s(text))])])];
        }
      }], null, true),
      model: {
        value: item.approval_id,
        callback: function callback($$v) {
          _vm.$set(item, "approval_id", $$v);
        },
        expression: "item.approval_id"
      }
    })] : [_c('div', {
      staticClass: "d-flex align-items-center form-control-plaintext"
    }, [_c('img', {
      staticClass: "rounded-circle mr-2",
      attrs: {
        "src": _vm.getSelectedApprovalPhoto(item.approval_id) || _vm.$getInitials(_vm.getSelectedApprovalText(item.approval_id)),
        "alt": "avatar",
        "width": "25",
        "height": "25"
      }
    }), _c('span', [_vm._v(" " + _vm._s(_vm.getSelectedApprovalText(item.approval_id) || '-') + " ")])])]], 2), !_vm.isDetail ? _c('b-col', {
      staticClass: "px-0",
      attrs: {
        "md": "1"
      }
    }, [index == 0 ? [_c('b-button', {
      attrs: {
        "variant": "primary"
      },
      on: {
        "click": _vm.addApproval
      }
    }, [_c('i', {
      staticClass: "fas fa-plus"
    })])] : [_c('b-button', {
      attrs: {
        "variant": "danger"
      },
      on: {
        "click": function click($event) {
          return _vm.deleteApproval(index);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-trash-alt"
    })])]], 2) : _vm._e()], 1);
  }) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }